
import './App.css';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import MapView from './MapView'
// import Firebase from './Firebase/Firebase';
import ReffenMapView from './maps/ReffenMapView';
// new Firebase()

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<MapView />}/>
        <Route path="/reffen" element={<ReffenMapView />} />
        {/* </Route> */}
      </Routes>
    </BrowserRouter>
  );
}

export default App;
